import { JobTitle } from './job-title.model';

export class ShiftBlock {
  id: number;
  costCenterId: number;
  startHour: number;
  endHour: number;
  isWeekday: boolean;
  isWeekend: boolean;
  isSaturday: boolean;
  isSunday: boolean;
  jobTitles: JobTitle[];
  fixedStaffing: { [jobTitleId: string] : number };
  previousShiftBlockId: number;
  staffingGrid: { [jobTitleId: string] : { [censusValue: string] : number } };
  description: string; 
  created: Date;
  inactivated: Date;
  addOns: number;
  isMissedBlock ? : boolean ;
  blockLength:number;
}
